import { Mediaclip } from '../../../interfaces/mediaclip';
import { NgForm } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'mediaclip-details-chapters',
	templateUrl: './mediaclip-details-chapters.component.html',
	styleUrls: ['./mediaclip-details-chapters.component.scss']
})


export class MediaclipDetailsChaptersComponent implements OnInit {
	@Input() form: NgForm;
	@Input() mediaclip: Mediaclip;

	ngOnInit() {

	}
}
